var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticStyle: { "margin-bottom": "15px" } }, [
      _c("span", { staticClass: "common-title" }, [_vm._v("其他资产")]),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "text-color-blue pointer right-oper",
          on: {
            click: function($event) {
              _vm.showMore = !_vm.showMore
            }
          }
        },
        [
          _vm._v(
            "\n      " + _vm._s(_vm.showMore ? "收起" : "展开") + "\n      "
          ),
          _c("a-icon", {
            staticStyle: { "font-size": "12px" },
            attrs: { type: _vm.showMore ? "up" : "down" }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("table", { staticClass: "table-common" }, [
      _vm._m(0),
      _vm._v(" "),
      _vm.showMore
        ? _c(
            "tbody",
            [
              _vm._l(_vm.pageData, function(item, index) {
                return _c("tr", { key: index }, [
                  _c("td", [_vm._v(_vm._s(item.fileNm))]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(item.createUser))]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      _vm._s(
                        _vm._f("dateFormat")(
                          item.createTime,
                          "YYYY-mm-dd HH:MM:SS"
                        )
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c(
                      "a",
                      {
                        on: {
                          click: function($event) {
                            return _vm.downloadFile(item)
                          }
                        }
                      },
                      [_vm._v("下载")]
                    )
                  ])
                ])
              }),
              _vm._v(" "),
              _vm.pageData.length == 0
                ? _c("tr", [
                    _c(
                      "td",
                      {
                        staticStyle: { "text-align": "center" },
                        attrs: { colspan: "8" }
                      },
                      [_vm._v("暂无数据")]
                    )
                  ])
                : _vm._e()
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.showMore ? _c("tbody", [_vm._m(1)]) : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("文件名称")]),
        _vm._v(" "),
        _c("th", [_vm._v("上传人")]),
        _vm._v(" "),
        _c("th", [_vm._v("上传日期")]),
        _vm._v(" "),
        _c("th", [_vm._v("操作")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c(
        "td",
        {
          staticStyle: {
            "text-align": "center",
            color: "#999",
            "font-size": "18px"
          },
          attrs: { colspan: "8" }
        },
        [_vm._v("\n          ···\n        ")]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-65c1e9ea", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65c1e9ea","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/gold-page/gold-detail-other-file.vue
// module id = Fhuj
// module chunks = 1